import { render, staticRenderFns } from "./matters_need_attention.vue?vue&type=template&id=75b27ccc&scoped=true"
import script from "./matters_need_attention.vue?vue&type=script&lang=js"
export * from "./matters_need_attention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b27ccc",
  null
  
)

export default component.exports